import * as React from "react";
import { DocumentAdd20Regular } from "@fluentui/react-icons";
import {
    OpenWindowConfig,
    useWindowManager,
} from "../../windowManager/WindowManagerContext";
import {
    DokumentAuswahl,
    type DokumentAuswahlErgebnis,
    type DokumentAuswahlProps,
} from "./DokumentAuswahl";

/**
 * Die Dokument-Auswahl als WindowManager-Fenster — die Hülle für den
 * Mail-Composer, der selbst in einem solchen Fenster lebt und dessen Welt
 * keine der beiden Dialog-Schichten des Refined-Designs kennt.
 *
 * Schließen erledigt die Hülle: die Fläche sagt nur „übernommen" oder
 * „abgebrochen" und weiß nichts davon, worin sie steckt.
 */

export type DokumentAuswahlFensterParams = Omit<
    DokumentAuswahlProps,
    "onAbbrechen" | "onUebernehmen"
> & {
    /** Fenstertitel; ohne Angabe „Dokument auswählen". */
    titel?: string;
    onUebernehmen: (auswahl: DokumentAuswahlErgebnis) => void;
};

const Fenster: React.FC<DokumentAuswahlFensterParams & { windowId: string }> = ({
    windowId,
    titel: _titel,
    onUebernehmen,
    ...rest
}) => {
    const { closeWindow } = useWindowManager();
    return (
        <DokumentAuswahl
            {...rest}
            imFenster
            onUebernehmen={(auswahl) => {
                onUebernehmen(auswahl);
                closeWindow(windowId);
            }}
            onAbbrechen={() => closeWindow(windowId)}
        />
    );
};

/** Öffnet die Auswahl als Fenster und gibt dessen Id zurück. */
export const openDokumentAuswahl = (
    openWindow: (config: OpenWindowConfig) => void,
    params: DokumentAuswahlFensterParams,
): string => {
    const windowId = `dok-auswahl-${Date.now()}`;
    openWindow({
        id: windowId,
        title: params.titel ?? "Dokument auswählen",
        icon: React.createElement(DocumentAdd20Regular),
        initialSize: { width: 900, height: 560 },
        center: true,
        render: () => React.createElement(Fenster, { windowId, ...params }),
    });
    return windowId;
};

export default openDokumentAuswahl;
